module.exports = __webpack_public_path__ + "static/27-1d1efcdca52e1ca3abc5f727f40fe0a3.png";